import FlashSVG from "~/public/static/icons/flash.svg";
import Image from "next/image";

export default (props) => {
  return (
    <div
      className="charge-button"
      onClick={props.onClick}
    >
      {/* <FlashSVG width={25} height={30} /> */}
      <Image
        src={FlashSVG}
        width={20}
        height={24}
      />
      <div>充电支持Ta</div>
      <style jsx>{`
        .charge-button {
          background: url(/static/icons/charge-circle@2x.png) 50% no-repeat;
          background-size: contain;
        }
      `}</style>
    </div>
  );
};
